import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown';
import 'react-simple-dropdown/styles/Dropdown.css';
import Avatar from './Avatar';

class DropdownUser extends Component {
  static propTypes = {
    avatar: PropTypes.string,
    name: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
  };

  static defaultProps = {
    avatar: null,
  };

  renderTrigger() {
    if (this.props.mobile) {
      return <Avatar src={this.props.avatar} name={this.props.name} className="u-w-8 u-h-8 u-border-white u-border u-p-0" />;
    }
    return <Avatar src={this.props.avatar} name={this.props.name} className="u-w-11 u-h-11" />;
  };

  render() {
    return (
      <Dropdown
        renderTrigger={this.renderTrigger.bind(this)}
        items={this.props.items}
        triggerClassName="dropdown-trigger"
        contentClassName="dropdown-user animated bounceIn"
        listClassName="topbar-dropdown"
        addMarginTop={false}
        {...this.props}
      />
    );
  }
}

export default DropdownUser;
